import AniLink from "gatsby-plugin-transition-link/AniLink"
import React from "react"
import CategoryLink from "./category-link"

const articleMeta = ({ article }) => {
  return (
    <div className="article-meta">
      <h1>
        <AniLink fade to={article.link}>
          {article.title}
        </AniLink>
      </h1>
      <div className="article-date">
        <span className="article-month">
          {article.date.toLocaleString("en-us", { month: "short" })}
        </span>
        <span className="article-day">{article.date.getDate()}</span>
        <span className="article-year">{article.date.getFullYear()}</span>
      </div>

      <div className="meta-info">
        <span className="meta-cats">
          in{" "}
          {article.categories
            .map(cat => <CategoryLink key={cat} cat={cat} />)
            .reduce((prev, curr) => [prev, ", ", curr])}
        </span>

        <span className="meta-comments">
          <a href="#respond">No responses</a>
        </span>
      </div>
    </div>
  )
}

export default articleMeta
